const buildEmptyIncome = () => {
  return {
    monthly_living_expenses_post_loan: {
      groceries: "",
      clothing: "",
      transport: "",
      communication: "",
      recreation: "",
      child_care: "",
      pet_care: "",
      health: "",
      health_insurance: "",
      general_insurance: "",
      sickness: "",
      public_school: "",
      private_school: "",
      higher_edu: "",
      other: "",
    },
  };
};

export const normalizeIncomeDetails = (rawSection = {}) => {
  const normalized = {
    monthly_living_expenses_post_loan: {
      ...buildEmptyIncome().monthly_living_expenses_post_loan,
      ...(rawSection.monthly_living_expenses_post_loan || {}),
    },
  };

  return normalized;
};

export const buildPersistedIncomeDetails = (normalizedSection) => {
  return {
    monthly_living_expenses_post_loan: {
      ...normalizedSection.monthly_living_expenses_post_loan,
    },
  };
};

export const calculateTotal = (expenses) => {
  let total = 0;
  Object.keys(expenses).forEach((key) => {
    if (key !== "other" && !isNaN(expenses[key])) {
      total += Number(expenses[key] || 0);
    }
  });
  return total;
};
